<template>
    <svg
        class="svg-indicate-line"
        xmlns="http://www.w3.org/2000/svg"
        width="145"
        height="22"
        viewBox="0 0 145 22"
        fill="none"
    >
        <path
            d="M0.999994 21L9.9845 9.90026C14.5413 4.27071 21.3966 1 28.6392 1H144"
            stroke="url(#paint0_linear_1374_5538)"
            stroke-width="2"
            stroke-linecap="round"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1374_5534"
                x1="144"
                y1="-8.99934"
                x2="-25.959"
                y2="-8.99934"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#37E6FE" />
                <stop offset="1" />
            </linearGradient>
        </defs>
        <defs>
            <linearGradient
                id="paint0_linear_1374_5538"
                x1="1"
                y1="-8.99934"
                x2="170.959"
                y2="-8.99934"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#37E6FE" />
                <stop offset="1" />
            </linearGradient>
        </defs>
    </svg>
</template>

<style lang="less">
    .svg-indicate-line.reverse {
        path {
            d: path('M144 21L135.015 9.90026C130.459 4.27071 123.603 1 116.361 1H1');
            stroke: url('#paint0_linear_1374_5534');
        }
    }
</style>
